import React from "react";
import { StepName, StepProps } from "../../types";
import { useWebTranslation } from "translations";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { useCurrentInsuranceByAnimalId } from "components/Signup/store/selectors/insurance";
import { updateInsuranceById } from "components/Signup/store/slices/animals";
import { MultipetDisclaimer } from "components/Signup/components/MultipetDisclaimer";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";

const NewOrSwitch = ({ next, transitioning }: StepProps) => {
  const { t } = useWebTranslation();

  const dispatch = useSignupDispatch();
  const { id } = useCurrentAnimal();
  const { previousInsurance, id: insuranceId } =
    useCurrentInsuranceByAnimalId(id);

  const options: {
    label: string;
    value: boolean;
    id: string;
    nextStep: StepName;
  }[] = [
    {
      label: t("global.yes"),
      value: true,
      id: "current-insurance",
      nextStep: "fetch-current-insurance-question",
    },
    {
      label: t("global.no"),
      value: false,
      id: "new-insurance",
      nextStep: "species",
    },
  ];

  return (
    <>
      <ChatContainer leaving={transitioning}>
        <ChatMessage>
          <Typography color="black">
            {t("signup.new_or_switch.text_2")}
          </Typography>
        </ChatMessage>

        <Gutter size={2} />
        {options.map((item) => (
          <ChatMessage
            fromMe
            key={item.id}
            blink
            onPress={() => {
              dispatch(
                updateInsuranceById(
                  {
                    id: insuranceId,
                    update: {
                      previousInsurance: item.value,
                    },
                  },
                  { refetch: false }
                )
              );

              next(false, item.nextStep);
            }}
            active={
              previousInsurance !== undefined &&
              previousInsurance === item.value
            }
          >
            <div data-test-id={item.id} key={item.label}>
              {item.label}
            </div>
          </ChatMessage>
        ))}
        <MultipetDisclaimer />
      </ChatContainer>
    </>
  );
};

export default NewOrSwitch;
